const { default: tippy } = require("tippy.js");
const { default: counterUp } = require('counterup2');

jQuery(function ($) {
  (function searchformtoggle() {
    jQuery(".js-close-search-trigger").on("click", function () {
      jQuery(".header-content-right")
        .find(".header-search-modal")
        .removeClass("form-visible");
      jQuery('.header-content-right .search-form input[type="submit"]').fadeOut(
        "fast",
      );
      jQuery("#masthead").removeClass("js-search-modal-open");
    });
  })();

  jQuery(document).ready(function () {
    "use strict";

    jQuery("input.search-field").autoComplete({
      appendTo: ".header-search-modal",

      source: function (name, response) {
        $.ajax({
          type: "POST",
          dataType: "json",
          url: barker_brettell_ajax.url,
          data: "action=get_listing_names&name=" + name,
          success: function (data) {
            response(data);
            // console.log(data);
          },
        });
      },
      renderItem: function (item, search) {
        search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
        var re = new RegExp("(" + search.split(" ").join("|") + ")", "gi");
        return (
          '<div class="autocomplete-suggestion" data-val="' +
          item +
          '">' +
          item.replace(re, "<b>$1</b>") +
          "</div>"
        );
      },
      onSelect: function (e, term, item) {
        // console.log('selected');
        //  alert('Item "'+item.data('langname')+' ('+item.data('lang')+')" selected by '+(e.type == 'keydown' ? 'pressing enter' : 'mouse click')+'.');
      },
    });

    //Concept Car tooltip
    if (jQuery("#concept-image-wrap").length) {
      (function showConceptCar() {
        jQuery("#concept-image-wrap")
          .delay(1000)
          .queue(function (next) {
            jQuery(this).css("opacity", "1");
            next();
          });
      })();

      jQuery(".hotspot").each(function () {
        tippy(jQuery(this)[0], {
          theme: "light",
          content: jQuery(this).find(".data-container").html(),
          allowHTML: true,
          interactive: true,
          placement: "bottom",
          animation: "fade",
        });
        // jQuery(this).LiteTooltip({
        //     location: 'bottom',
        //     trigger: 'hoverable',
        //     //trigger: 'click',
        //     textalign: 'left',
        //     issticky: false,
        //     padding: 16,
        //     title: jQuery(this).find('.data-container').html(),
        // });
      });

      jQuery(".hotspot_highlight").each(function () {
        tippy(jQuery(this)[0], {
          theme: "light",
          content: jQuery(this).find(".data-container").html(),
          allowHTML: true,
          interactive: true,
          placement: "bottom",
          animation: "fade",
        });

        // jQuery(this).LiteTooltip({
        //     location: 'bottom',
        //     trigger: 'hoverable',
        //     //trigger: 'click',
        //     textalign: 'left',
        //     issticky: false,
        //     padding: 16,
        //     title: jQuery(this).find('.data-container').html(),
        // });
      });

      // console.log("concept car wrapper found");
    }
  });

  var setPostHeight = function () {
    if (jQuery(window).innerWidth() >= 601) {
      jQuery(".blog-posts").each(function (idx, elm) {
        var LIheight = 0;
        jQuery(".post")
          .each(function () {
            if (jQuery(this).innerHeight() > LIheight)
              LIheight = jQuery(this).innerHeight() + 1;
          })
          .css("min-height", LIheight);
      });
    }
  };

  jQuery(document).ready(function () {
    setPostHeight();
    if (jQuery(".key-figures-component").length) {
      //first get the number parts from the text

      const callback = entries => {
        entries.forEach( entry => {
          const el = entry.target
          if ( entry.isIntersecting ) {
            counterUp( el, {
              duration: 2000,
              delay: 16,
            } )
          }
        } )
      }

      const IO = new IntersectionObserver( callback, { threshold: 1 } )
      jQuery(".statistic").each(function (idx, stat) {
        IO.observe(jQuery(stat)[0]);
      });
    }
  });

  jQuery(window).on("resize", function () {
    setPostHeight();
  });

  //Story modal
  jQuery(function () {
    if (
      jQuery(".gform_wrapper").length &&
      jQuery(".gform_wrapper").hasClass("gform_validation_error")
    ) {
      var top = jQuery(".gform_validation_error").position().top;
      // console.log(top);
      jQuery(window).scrollTop(top);
    }
  });

  (function popup() {
    var modal = jQuery(".modal");
    var subscribe_modal = jQuery(".subscribe-modal");
    var subscribe_modal_trigger = jQuery(".js-subscribe-modal-trigger");

    jQuery(subscribe_modal_trigger).on("click", function (event) {
      event.stopPropagation();
      event.preventDefault();
      jQuery("body").addClass("modal-visible");
      subscribe_modal.addClass("visible");
    });

    jQuery("html").bind("click", function (e) {
      if (jQuery("body").hasClass("modal-visible")) {
        if (!jQuery(e.target).closest("form").length) {
          jQuery(modal).removeClass("visible");
          jQuery("body").removeClass("modal-visible");
          e.preventDefault();
        }
      }
    });

    jQuery(".gform_confirmation_message a").click(function (e) {
      jQuery(modal).removeClass("visible");
      jQuery("body").removeClass("modal-visible");
      e.preventDefault();
    });

    if (window.location.hash) {
      // Fragment exists
      var hash = window.location.hash.substring(1);

      if (hash == "subform") {
        jQuery("body").addClass("modal-visible");
        subscribe_modal.addClass("visible");
      }

      // console.log(hash);
    } else {
      // Fragment doesn't exist
      if (jQuery("body").hasClass("home")) {
        // jQuery('body').addClass('modal-visible');
        // subscribe_modal.addClass('visible').addClass('show-subscribe');
      }
    }
  })();
});

var s,
  case_study_filtering = {
    settings: {
      // NOTE: REDEFINE SELECTORS
      filter: jQuery(".js-case-study-filter-strip .filter select"),
      categoryTrigg: jQuery(".js-filter-by-category"),
      servicesTrigg: jQuery(".js-filter-by-service"),
      sectorTrigg: jQuery(".js-filter-by-sector"),
    },

    init: function () {
      s = this.settings;
      this.select_filters();
      this.loader();
      //this.test();
    },

    loader: function () {
      jQuery(
        '.js-case-study-filter-strip .text-filter input[type="search"]',
      ).attr("placeholder", "Type to search");

      if (jQuery(".blog-posts").length) {
        jQuery(document).ready(function () {
          jQuery(".loading").fadeOut("fast");
          jQuery(".blog-posts").fadeIn("fast");
          jQuery(".js-filter-by-category").removeAttr("disabled");
          jQuery(".js-filter-by-service").removeAttr("disabled");
          jQuery(".js-filter-by-sector").removeAttr("disabled");

          // console.log("success");
        });
      }
    },
    //post filtering
    select_filters: function () {
      var flag, selected_option, hostname;
      hostname =
        "http://" + jQuery(location).attr("hostname") + "/case-studies/";

      flag = false;

      //Toggle dropdown
      s.filter.on("change", function (e) {
        e.preventDefault();

        selected_option = jQuery(this).val();

        //console.log(selected_option);
        //  s.test();
        if (flag) {
          s.filter.closest(".filter").removeClass("active");
        }

        //If 'all' is selected then remove class of active from filter and show all posts
        if (
          jQuery(this).val() === "service-all" ||
          jQuery(this).val() === "sector-all"
        ) {
          jQuery(this).closest(".styled-select").removeClass("active");
          //jQuery('.blog-posts .post').show();
          jQuery("#news .blog-posts").removeClass("no_results");
          flag = false;

          window.location.href = hostname;

          //else filter based on criteria
        } else {
          //console.log('Add class of active to filter');
          //jQuery(this).closest('.filter').addClass('active');
          flag = true;
          if (jQuery(this).is(s.categoryTrigg)) {
            //reset
            jQuery(s.servicesTrigg).prop("selectedIndex", 0);
            jQuery(s.sectorTrigg).prop("selectedIndex", 0);
            jQuery("#text_search").val("");

            var categoryQueryURL;
            categoryQueryURL = hostname + "/category/" + selected_option;
            window.location.href = categoryQueryURL;

            // console.log("post category filter trig");
          } else if (jQuery(this).is(s.servicesTrigg)) {
            //reset
            jQuery(s.categoryTrigg).prop("selectedIndex", 0);
            jQuery(s.sectorTrigg).prop("selectedIndex", 0);
            jQuery("#text_search").val("");

            var servicesQueryURL;
            servicesQueryURL = hostname + "?services=" + selected_option;
            window.location.href = servicesQueryURL;
            // console.log(servicesQueryURL);
          } else if (jQuery(this).is(s.sectorTrigg)) {
            //reset
            jQuery(s.categoryTrigg).prop("selectedIndex", 0);
            jQuery(s.servicesTrigg).prop("selectedIndex", 0);
            jQuery("#text_search").val("");

            var sectorQueryURL;
            sectorQueryURL = hostname + "?sectors=" + selected_option;
            window.location.href = sectorQueryURL;
          } else {
            // console.log("No matching filters found for select box");
          }
        }
      });
    },
  };

//Execute functions
jQuery(document).ready(function ($) {
  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }
  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
  function eraseCookie(name) {
    document.cookie = name + "=; Max-Age=-99999999;";
  }

  if ($(".file_request_overlay").length) {
    $(".file_request_overlay a.close-overlay").bind("click", function (e) {
      $(this).parent().parent().parent().parent().removeClass("visible");
      // console.log("hello");
      e.preventDefault();
    });
    $(".file_request_link_wrap > a").on("click", function (e) {
      var cookieCheck = getCookie("bb_di_confirmed");
      if (cookieCheck !== undefined && cookieCheck == 1) {
        var download_link = $(this)
          .next()
          .find(".download-link-url a")
          .attr("href");
        window.open(download_link, "File Download");
      } else {
        $(this).next().addClass("visible");
        $(this).next().unbind("click");
        $(this)
          .next()
          .bind("click", function (e) {
            if ($(e.target).hasClass("file_request_overlay")) {
              $(this).removeClass("visible");
              e.preventDefault();
              e.stopPropagation();
            }
          });
      }
      e.preventDefault();
    });
    $(document).on("gform_confirmation_loaded", function (event, formId) {
      $(".download-link-url").addClass("visible");
      setCookie("bb_di_confirmed", 1, 2555);
    });
  }

  function updateFilters() {
    var selected_filters = $(
      ".filter-strip.multi-select-filter .select-options input:checked",
    );
    var lookupClasses = "";
    $(".people-list li").hide();
    $.each(selected_filters, function (ind, filter) {
      $(".people-list li." + filter.id).show();
      //console.log(filter.id);
    });

    if (selected_filters.length == 0) {
      //console.log('no filters');
      $(".people-list li").show();
    }

    $("h3.no-results").hide();
    if (!$(".people-list li:visible").length) {
      $("h3.no-results").show();
    }
  }

  if ($(".filter-strip.multi-select-filter").length) {
    $("body").on("click", function (e) {
      if (!$(e.target).parents(".styled-select").length) {
        $(".styled-select.visible").toggleClass("visible");
      }
    });
    $(".filter-strip.multi-select-filter .selected-option").bind(
      "click",
      function (e) {
        if ($(this).parent().hasClass("visible")) {
          $(this).parent().toggleClass("visible");
        } else {
          $(".styled-select.visible").toggleClass("visible");
          $(this).parent().toggleClass("visible");
        }
        e.preventDefault();
      },
    );
    $(
      ".filter-strip.multi-select-filter .select-options input.select-option",
    ).on("change", function (e) {
      var selected = $(this).parents("ul").find("input:checked").length;
      if (selected) {
        $(this).parents(".select-options").prev().addClass("options-selected");
      } else {
        $(this)
          .parents(".select-options")
          .prev()
          .removeClass("options-selected");
      }
      updateFilters();
      e.preventDefault();
    });
    if ($(".selected-option.options-selected").length) {
      updateFilters();
    }
  }

  var timelineBlocks = $(".cd-timeline-block"),
    offset = 0.8;
  //hide timeline blocks which are outside the viewport
  hideBlocks(timelineBlocks, offset);
  //on scolling, show/animate timeline blocks when enter the viewport
  $(window).on("scroll", function () {
    !window.requestAnimationFrame
      ? setTimeout(function () {
          showBlocks(timelineBlocks, offset);
        }, 100)
      : window.requestAnimationFrame(function () {
          showBlocks(timelineBlocks, offset);
        });
  });
  function hideBlocks(blocks, offset) {
    blocks.each(function () {
      jQuery(this).offset().top >
        $(window).scrollTop() + $(window).height() * offset &&
        jQuery(this)
          .find(".cd-timeline-img, .cd-timeline-content")
          .addClass("is-hidden");
    });
  }
  function showBlocks(blocks, offset) {
    blocks.each(function () {
      jQuery(this).offset().top <=
        $(window).scrollTop() + $(window).height() * offset &&
        jQuery(this).find(".cd-timeline-img").hasClass("is-hidden") &&
        jQuery(this)
          .find(".cd-timeline-img, .cd-timeline-content")
          .removeClass("is-hidden")
          .addClass("bounce-in");
    });
  }

  function resizeHeader() {
    $(".page-header[data-mobile-bg]").each(function () {
      if ($(window).width() < 768) {
        $(this).css(
          "background-image",
          "url(" + $(this).attr("data-mobile-bg") + ")",
        );
      } else {
        $(this).css(
          "background-image",
          "url(" + $(this).attr("data-desktop-bg") + ")",
        );
      }
    });
  }

  resizeHeader();
  $(window).on("resize", function () {
    resizeHeader();
  });

  $("#sidebar-navigation li.menu-item a").on("click", function (e) {
    jQuery("#sidebar-navigation").removeClass("visible");
    jQuery("body").removeClass("js-menu-open");
  });

  const EU_TIMEZONES = [
    "Europe/Vienna",
    "Europe/Brussels",
    "Europe/Sofia",
    "Europe/Zagreb",
    "Asia/Famagusta",
    "Asia/Nicosia",
    "Europe/Prague",
    "Europe/Copenhagen",
    "Europe/Tallinn",
    "Europe/Helsinki",
    "Europe/Paris",
    "Europe/Berlin",
    "Europe/Busingen",
    "Europe/Athens",
    "Europe/Budapest",
    "Europe/Dublin",
    "Europe/Rome",
    "Europe/Riga",
    "Europe/Vilnius",
    "Europe/Luxembourg",
    "Europe/Malta",
    "Europe/Amsterdam",
    "Europe/Warsaw",
    "Atlantic/Azores",
    "Atlantic/Madeira",
    "Europe/Lisbon",
    "Europe/Bucharest",
    "Europe/Bratislava",
    "Europe/Ljubljana",
    "Africa/Ceuta",
    "Atlantic/Canary",
    "Europe/Madrid",
    "Europe/Stockholm",
  ];

  // if (!EU_TIMEZONES.includes(Intl.DateTimeFormat().resolvedOptions().timeZone) && !localStorage.getItem('bb_eu_redirect_actioned')) {
  //     localStorage.setItem('bb_eu_redirect_actioned', 'true');
  //     window.location.href = 'https://www.barkerbrettell.co.uk/sweden/?lang=en';
  // }
  

  //listen for changes to the hash and if it changes to #resources then scroll to the resource filter strip
  $(window).on("hashchange", function () {
    var whitelist = [
      "#ip-committee",
      "#review",
      "#reporting",
      "#register",
      "#ip-valuation",
      "#branding",
      "#legal-templates",
      "#processes",
      "#training",
      "#policies",
      "#governance",
    ];

    //check if the new hash is in the whitelist and if the page url contains /ip-strategy
    if (
      whitelist.includes(window.location.hash) &&
      window.location.pathname.includes("/ip-strategy")
    ) {
      $(".panel-content").removeClass("active");
      $(".panel-content#" + window.location.hash.substring(1)).addClass(
        "active",
      );
    }
  });

  //check for page load with a hash and if the hash is in the whitelist then scroll to the resource filter strip
  $(document).ready(function () {
    var whitelist = [
      "#ip-committee",
      "#review",
      "#reporting",
      "#register",
      "#ip-valuation",
      "#branding",
      "#legal-templates",
      "#processes",
      "#training",
      "#policies",
      "#governance",
    ];
    if (
      whitelist.includes(window.location.hash) &&
      window.location.pathname.includes("/ip-strategy")
    ) {
      $(".panel-content").removeClass("active");
      $(".panel-content#" + window.location.hash.substring(1)).addClass(
        "active",
      );
    }
  });
});

jQuery(document).ready(function ($) {

  //check the first section on the page and get its background color and set the header background color to match it
  if ($("#header-rebrand").length) {
    var first_section_bg = $(".page-container .content section").first().css("background-color") ?? "#fff";
    if (first_section_bg === "rgba(0, 0, 0, 0)") {
      first_section_bg = "#fff";
    }
    $("#header-rebrand").css("background-color", first_section_bg);
  }

  //check for scroll and if the scroll is greater than 100px then add a class to the header to change its background color
  $(window).scroll(function () {
    if ($(this).scrollTop() >= 1) {
      $("#header-rebrand").addClass("scrolled");
    } else {
      $("#header-rebrand").removeClass("scrolled");
    }
  });

  case_study_filtering.init();

    $(".menu-item-has-children > a").click((e) => {
        e.preventDefault();
        $('.menu-item-has-children').not($(e.target).parent()).removeClass("menu-open");
        if ($(e.target).parent().hasClass("menu-open")) {
            $("body").removeClass("show-underlay");
            $(e.target).parent().removeClass("menu-open");
        } else {
            $("body").addClass("show-underlay");
            $(e.target).parent().addClass("menu-open");
        }
    });
    $('.menu-item').click((e) => {
        let clicked = e.target;

    if (!$(clicked).parent().hasClass("menu-item-has-children")) {
      e.stopPropagation();
    }
  });

  //footer dropdown
  $(".footer-grid").click((e) => {
    e.preventDefault();
    $(".footer-grid").not($(e.target).parent()).removeClass("footer-open");
    if ($(e.target).parent().hasClass("footer-open")) {
      $("body").removeClass("show-underlay");
      $(e.target).parent().removeClass("footer-open");
    } else {
      $("body").addClass("show-underlay");
      $(e.target).parent().addClass("footer-open");
    }
  });
  $(".footer-grid").click((e) => {
    let clicked = e.target;

    if (!$(clicked).parent().hasClass("footer-grid")) {
      e.stopPropagation();
    }
  });
//filter buttons

  $('.locations-component .wp-block-button__link').click((e) => {
    e.preventDefault();
    let clicked = e.target;
    $('.locations-component .wp-block-button__link').not($(clicked)).parent().removeClass("active");
    $(clicked).parent().toggleClass("active");
  });

  const buttons = document.querySelectorAll(".filter button");
  const submitBtn = document.querySelectorAll(".submit-btn");
  buttons.forEach((btns) => {
    btns.classList.add("icon-sml-chevron-down");
  });
  submitBtn.forEach((submit) => {
    submit.classList.remove("icon-sml-chevron-down");
  });
  $('body').on('click', '.reset-search-input a', function(e) {
    $(this).parents('label').find('input').val('');
    $(this).parents('label').find('input').focus();
    e.preventDefault();
  });
  $('body').on('click', '.posts-grid .post:not(.video-insight):not(.has-slides)', function(e) {
    var link = $(this).find('.wp-block-button[class*="icon-sml-angle-arrow"]').find('a');
    if (!link.length) {
      var link = $(this).find('.link').find('a');
    }
    if (link.length && e.target.tagName.toLowerCase() !== 'a') {
      link[0].click();
      e.preventDefault();
      e.stopPropagation();
    }
  });
  $('body').on('click', '.posts-grid .post.video-insight:not(.has-slides)', function(e) {
    var link = $(this).find('.wp-block-button[class*="icon-sml-angle-arrow"]').find('a');
    if (link.length && e.target.tagName.toLowerCase() !== 'a') {
      link[0].click();
      // console.log('clicked on video insight post');
    }
  });
  $('body').on('click', '.posts-grid .post.video-insight.has-slides', function(e) {
    var link = $(this).find('.wp-block-button[class*="icon-sml-angle-arrow"]').find('a');
    if (e.target.tagName.toLowerCase() !== 'a') {
      link[0].click();
      // console.log('clicked on video insight post');
    }
  });
  $('body').on('click', '.flex-grid .wp-block-column', function(e) {
    var link = $(this).find('.wp-block-button[class*="icon-sml-angle-arrow"]').find('a').attr('href');
    if (link && e.target.tagName.toLowerCase() !== 'a') {
      window.location.href = link;
      e.preventDefault();
      e.stopPropagation();
    }
  });
  $('body').on('click', '.services-columns .wp-block-column.has-background', function(e) {
    var link = $(this).find('.wp-block-button[class*="icon-sml-angle-arrow"]').find('a').attr('href');
    if (link && e.target.tagName.toLowerCase() !== 'a') {
      window.location.href = link;
      e.preventDefault();
      e.stopPropagation();
    }
  }); 
  $('body').on('click', '.people-list li', function(e) {
    var link = $(this).find('a[class*="icon-sml-angle-arrow"]').attr('href');
    if (link && e.target.tagName.toLowerCase() !== 'a') {
      window.location.href = link;
      e.preventDefault();
      e.stopPropagation();
    }
  });
  $('body').on('click', '.panel-block:has(.wp-block-buttons)', function(e) {
    var link = $(this).find('.wp-block-button[class*="icon-sml-angle-arrow"]').find('a').attr('href');
    if (link && e.target.tagName.toLowerCase() !== 'a') {
      window.location.href = link;
      e.preventDefault();
      e.stopPropagation();
    }
  });

  $('body').on('click', '.resource-item:has(.wp-block-buttons)', function(e) {
    var link = $(this).find('.wp-block-button[class*="icon-sml-angle-arrow"]').find('a').attr('href');
    if (link && e.target.tagName.toLowerCase() !== 'a') {
      window.location.href = link;
      e.preventDefault();
      e.stopPropagation();
    }
  });

  $('body').on('click', '.profile-card', function(e) {
    var link = $(this).find('a[class*="profile"]').attr('href');
    if (link && e.target.tagName.toLowerCase() !== 'a') {
      window.location.href = link;
      e.preventDefault();
      e.stopPropagation();
    }
  });

  $('body').on('click', '.search-content-jump a', function(e) {
    //smooth scroll to the target
    var target = $(this).attr('href');
    if (target && target.startsWith('#')) {
      var $target = $(target);
      if ($target.length) {
        $('html, body').animate({
          scrollTop: $target.offset().top - 200
        }, 500);
        e.preventDefault();
      }
    }
  });

  $('body').on('click', '.back-to-search a', function(e) {
    //smooth scroll to the target
    var target = $(this).attr('href');
    if (target && target.startsWith('#')) {
      var $target = $(target);
      if ($target.length) {
        $('html, body').animate({
          scrollTop: $target.offset().top - 200
        }, 500, function(){
          //focus on the search input
          var $searchInput = $('#search');
          if ($searchInput.length) {
            $searchInput.focus();
          }
        });
        e.preventDefault();
      }
    }
  });

  //on scroll once the '#search' goes out of view, show the 'back to search' button
  $(window).on('scroll', function() {
    var searchSection = $('#search');
    var backToSearch = $('.back-to-search');
    var filtersActive = $('.filters.active');
    if (searchSection.length && backToSearch.length) {
      if ($(window).scrollTop() > (searchSection.offset().top - $('.site-header').outerHeight() + (filtersActive.length ? filtersActive.outerHeight() : 0) + searchSection.outerHeight())) {
        backToSearch.addClass('active');
      } else {
        backToSearch.removeClass('active');
      }
    }
    //when the footer '.barker-bretell-footer' comes into view, hide the 'back to search' button
    var footer = $('.barker-bretell-footer');
    // console.log('footer length:', footer.length);
    var loadmorebtn = $('.load-more-btn');

    if (footer.length && backToSearch.length && loadmorebtn.not(':visible').length) {
      if (($(window).scrollTop() + $(window).outerHeight() + $('.site-header').outerHeight()) > footer.offset().top) {
        backToSearch.removeClass('active');
      }
    }
  });

  $('body').on('click', '.filter .filters .filter-label', function(e) {
    var filter_dropdown = $(this).closest('.filters');
    filter_dropdown.toggleClass('active');
  });
});

//navigation
document.addEventListener("DOMContentLoaded", function () {
  //Search bar
  const navigation = document.querySelector(".navigation-bar");
  const navBar = document.querySelector(".menu");
  const searchIcon = document.querySelector(".js-trigger-search");
  const searchBar = document.querySelector(".header-search-modal");
  const contact = document.querySelector(".contact a");
  const closeSearch = document.querySelector(".js-close-search-trigger");
  const MagnifyingGlass = document.querySelector(".header-search-modal input.search-submit");
  const headerRebrand = document.querySelector(".site-header .contain");
  searchIcon.addEventListener("click", function () {
    searchBar.style.display = "flex";
    searchIcon.style.display = "none";
    navBar.style.display = "none";
    navigation.classList.add("search-open");
    contact.innerHTML = "Close";
    contact.removeAttribute("href");
    contact.classList.add("js-close-search-trigger");
    contact.style.cursor = "pointer";
    headerRebrand.classList.add("search--bar-open");
    // MagnifyingGlass.classList.add("icon-ui-magnifying-glass");
    if (contact.classList.contains("js-close-search-trigger")) {
      contact.addEventListener("click", function (e) {
        e.preventDefault();
        searchBar.style.display = "none";
        searchIcon.style.display = "flex";
        navBar.style.display = "flex";
        navigation.classList.remove("search-open");
        contact.innerHTML = "Contact";
        contact.setAttribute("href", "/contact/");
        contact.classList.remove("js-close-search-trigger");
        headerRebrand.classList.remove("search--bar-open");
      }, { once: true });
    }
  });

  //Footer: Subscribe Modal
  const modal = document.querySelector(".SubscribeModal");
  const modalBtn = document.querySelector(".subscribeBtn");
  // console.log("modalBtn:", modalBtn);
  const modalClose = document.querySelector(
    ".SubscribeModal .content .icon-ui-close",
  );
  if (modalBtn && modalClose) {
    modalBtn.addEventListener("click", function (e) {
      e.preventDefault();
      modal.classList.add("active");
      $("body").addClass("no-scroll");
    });
    modalClose.addEventListener("click", function (e) {
      e.preventDefault();
      modal.classList.remove("active");
      $("body").removeClass("no-scroll");
    });
  }
  window.addEventListener("click", function (e) {
    if (e.target === modal) {
      modal.classList.remove("active");
      $("body").removeClass("no-scroll");
      e.preventDefault();
    }
  });
});

//burger menu mobile
document.addEventListener("DOMContentLoaded", function () {
  const burgerMenu = document.querySelector(".js-burger-trigger");
  const mobileNav = document.querySelector(".navigation-bar");
  const closeBtn = document.querySelector(".js-close-burger-trigger");
  const mobileSearch = document.querySelector(".mobile-search");
  const searchBtn = document.querySelector(".js-trigger-search-mobile");
  const searchClose = document.querySelector(".js-close-search-trigger-mobile");
  closeBtn.style.display = "none";
  searchClose.style.display = "none";
  //burger menu
  burgerMenu.addEventListener("click", function () {
    burgerMenu.style.display = "none";
    burgerMenu.setAttribute("aria-expanded", "true");
    mobileNav.setAttribute("aria-expanded", "true");
    closeBtn.style.display = "block";
    closeBtn.setAttribute("aria-expanded", "true");
    searchBtn.style.display = "none";
    searchBtn.setAttribute("aria-expanded", "false");
  });
  closeBtn.addEventListener("click", function () {
    burgerMenu.style.display = "block";
    burgerMenu.setAttribute("aria-expanded", "false");
    mobileNav.setAttribute("aria-expanded", "false");
    closeBtn.style.display = "none";
    closeBtn.setAttribute("aria-expanded", "false");
    searchBtn.style.display = "block";
    searchBtn.setAttribute("aria-expanded", "false");
  });
  //search bar mobile
  searchBtn.addEventListener("click", function () {
    mobileSearch.classList.add("active");
    mobileSearch.setAttribute("aria-expanded", "true");
    burgerMenu.style.display = "none";
    burgerMenu.setAttribute("aria-expanded", "false");
    searchClose.style.display = "block";
    searchClose.setAttribute("aria-expanded", "true");
    searchBtn.style.display = "none";
    searchBtn.setAttribute("aria-expanded", "false");
  });
  searchClose.addEventListener("click", function () {
    mobileSearch.classList.remove("active");
    mobileSearch.setAttribute("aria-expanded", "false");
    burgerMenu.style.display = "block";
    burgerMenu.setAttribute("aria-expanded", "false");
    searchClose.style.display = "none";
    searchClose.setAttribute("aria-expanded", "false");
    searchBtn.style.display = "block";
    searchBtn.setAttribute("aria-expanded", "false");
  });
});

jQuery(function($) {

    //check if we have a location hash in the url and if so then trigger a click on the corresponding location button

    $('.office-location-buttons a').on('click', function(e) {
        e.preventDefault();
        var officeLocation = $(this).data('office-location');
        //use the history api to update the url with the office location hash
        history.pushState(null, null, '#' + officeLocation);
        $('.office-location').removeClass('active');
        $('.office-location[data-office-location="' + officeLocation + '"]').addClass('active');
        $('.office-image').removeClass('active');
        $('.office-image[data-office-location="' + officeLocation + '"]').addClass('active');
        $('.office-location-buttons a').removeClass('active');
        $(this).addClass('active');
        //smooth scroll to the office location section
        $('html, body').animate({
            scrollTop: $('.office-location.active').offset().top - 360
        }, 500);
    });

    //add an on location hash change event listener to trigger a click on the corresponding location button
    $(window).on('hashchange load', function() {
        if ($('.office-location-buttons').length === 0) {
            return;
        }
        var locationHash = window.location.hash;
        // console.log('location hash changed:', locationHash);
        if (locationHash) {
            var locationButton = $('.office-location-buttons a[data-office-location="' + locationHash.substring(1) + '"]');
            // console.log('location button:', locationButton);
            if (locationButton.length) {
                locationButton.trigger('click');
            }
        }
    });

    if ($('.filter-strips').length) {
      var filter_selected = false;
      $('.js-checkbox-filter').each(function() {
        if ($(this).is(':checked')) {
          filter_selected = true;
        }
      });
      // console.log('Filter selected:', filter_selected);
      if (filter_selected) {
        // console.log('Filter selected, triggering filter button click');
        //trigger the filter button click to show the filter options
        $('.filter.submit-btn').trigger('click');
      }
    }
    $('.js-checkbox-toggle .filter button').on('click', function() {
      $(this).parents('.form-field-wrapper').find('.filter').not($(this).parent('.filter')).removeClass('active');
      $(this).parent('.filter').toggleClass('active');
    });

    //check for other click events on the page and if the click is not inside a filter then remove the active class from all filters
    $(document).on('click', function(e) {
      if ($(e.target).closest('.js-checkbox-toggle .filter').length === 0) {
        $('.js-checkbox-toggle .filter').removeClass('active');
      }
    });

    $('.js-checkbox-filter').on('change', function() {
      var selected_filters = [];
      var checkboxWrapper = $(this).closest('.dropdown-terms');
      checkboxWrapper.find('.js-checkbox-filter:checked').each(function() {
        selected_filters.push($(this).val());
      });
      var count = selected_filters.length;
      if (count > 0) {
        checkboxWrapper.parent().find('.selected').text(' (' + count + ')');
      } else {
        checkboxWrapper.parent().find('.selected').text('');
      }
    });

    $('body').on('click', '.video-insight.clone a.close-video', function(e) {
      var videoClone = $(this).parents('.video-insight.clone');
      videoClone.remove();
      // console.log('video clone removed');
      e.preventDefault();
    });
    $('body').on('click', '.video-insight:not(.clone) a[href="#view-video-modal"]', function(e) {
      var video = $(this).parents('.post');
      //clone the video element and append it to the modal
      var videoClone = video.clone();
      //append it after the current post in the posts-grid
      videoClone.addClass('video-active').addClass('clone');
      videoClone.prepend('<a href="#" class="close-video"><span class="icon-ui-close"></span></a>');
      //remove the inert tag from the videoClone
      videoClone.find('.wp-block-video').removeAttr('inert');
      videoClone.insertAfter(video.parents('.posts-grid').children().last());
      // console.log('video active');
      e.preventDefault();
    });

    //if we click the esc key and the clone video is active then remove the clone video
    $(document).on('keydown', function(e) {
      if (e.key === "Escape") {
        var videoClone = $('.video-insight.clone');
        if (videoClone.length) {
          videoClone.remove();
          // console.log('video clone removed');
        }
      }
    });

    $('.search-submit-container a[data-role="trigger-search"]').on('click', function(e) {
      e.preventDefault();
      var searchForm = $(this).closest('form');
      searchForm.submit();
    });

    $('body').on('click', function(e){
      //check if we are clicking inside '.navigation-bar' if not then make sure that the '.menu-open' class is removed from all '.menu-item-has-children' elements
      if ($(e.target).closest('.navigation-bar').length === 0) {
        $('.menu-item-has-children').removeClass('menu-open');
        $('body').removeClass('show-underlay');
      }
    });

    $(window).on('resize', function() {
      //add class to body to prevent transitions on the menu when resizing the window
      $('body').addClass('resizing');
      setTimeout(function() {
        $('body').removeClass('resizing');
      }, 500);
    });
});

//people dropdown filter 

document.addEventListener("DOMContentLoaded", function () {
const checkbox_Btn = document.querySelectorAll(".selected-option");
const checkbox_Dropdown = document.querySelectorAll(".select-options");
checkbox_Btn.forEach(buttons => {
  buttons.addEventListener("click", function (e) {
    e.preventDefault();
    checkbox_Dropdown.forEach(dropdowns => {
      if (dropdowns.style.display === "block") {
        dropdowns.classList.toggle("visable");
      }
    });
  })
});

});

